'use strict';

var d3 = require('d3');
var CalibrationReviewChart = function CalibrationReviewChart(AbstractChart, chartGroups, chartXAxis, chartYAxis, chartConstants, chartSimpleBars, chartTiles, chartCircle, calibrationAnalysisConstants) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters, chartType) {
    AbstractChart.call(this, container);
    var dispatch = d3.dispatch('rangechange');
    d3.rebind(this, dispatch, 'on');

    // chart components
    var groups = chartGroups('d1', formatters.tooltipFormatter, true);
    var m1Bars = chartSimpleBars('m1');
    var m2Bars = chartSimpleBars('m2');
    var tiles = chartTiles('d1', 'm2', 'tiles').withHeight(3);
    var xAxis = chartXAxis(formatters.xAxisTickFormatter);
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT);
    var circle = chartCircle('current', 3);
    xAxis = chartType === calibrationAnalysisConstants.CHART_TYPES.FARE ? xAxis.withTextRotation(calibrationAnalysisConstants.CHART_XAXIS_ROTATION.DEG_15) : xAxis.withTextRotation(calibrationAnalysisConstants.CHART_XAXIS_ROTATION.INDENT_NO_ROTATE);
    this.render = function (data, range) {
      range = range || [0, data.length];
      this.initChart(data, range, chartParams);
      this.scales = chartScales(this.params, this.data, this.visibleXRange);
      this.callForPreDataGroup([], this.scales);
      this.callForDataGroup([yAxisLeft, groups, m2Bars, m1Bars, tiles, circle, xAxis], this.scales);
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
CalibrationReviewChart.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants', 'ChartElementsSimpleBars', 'ChartElementsTiles', 'ChartElementsCircles', 'CalibrationAnalysisConstants'];
module.exports = CalibrationReviewChart;